export default "__VITE_ASSET__HYvQxT8$__"